import { DEFAULT_LOCALE } from '../hooks/use-locale';
import { ImageShape, VideoShape } from '../lib/types';
import { axiosAPI } from './axios-instance';
import { ApiResponse, AppLocale } from './lib/types';

export type SiteSettingsKeys = Partial<{
    main_first_screen_title: string;
    main_first_screen_big_text: string;
    main_first_screen_place: string;
    main_first_screen_date: string;
    main_first_screen_description: string;

    main_video_short: VideoShape;
    main_video_long: VideoShape;

    main_history_title: string;
    main_history_description: string;
    main_history_link_text: string;
    main_history_link: string;

    main_people_title: string;
    main_people_link_text: string;
    main_people_link: string;
    main_event_title: string;
    main_program_title: string;
    main_program_description: string;
    main_program_link_text: string;
    main_program_link: string;
    main_review_title: string;
    main_review_description: string;
    main_tariff_title: string;
    main_tariff_description: string;
    main_tariff_link_text: string;
    main_tariff_link: string;
    main_partner_title: string;
    main_partner_description: string;
    main_partner_button_text: string;
    main_other_event_title: string;
    main_other_event_description: string;
    main_other_event_link_text: string;
    main_other_event_link: string;
    main_post_title: string;
    main_post_link_text: string;
    main_post_link: string;

    participants_tariff_title: string;
    participants_tariff_description: string;
    participants_tariff_link_text: string;
    participants_tariff_link: string;
    participants_tariff_discount: string;

    participants_history_title: string;
    participants_history_description: string;
    participants_history_link_text: string;
    participants_history_link: string;

    participants_event_title: string;

    participants_faq_title: string;

    participants_service_title: string;
    participants_service_description: string;
    participants_service_link_text: string;
    participants_service_link: string;

    participants_form_title: string;
    participants_form_description: string;
    participants_form_link_text: string;
    participants_form_link: string;

    partners_company_title: string;
    partners_faq_title: string;

    visitors_expo_title: string;

    visitors_history_title: string;
    visitors_history_description: string;
    visitors_history_link_text: string;
    visitors_history_link: string;

    visitors_event_title: string;
    visitors_event_description: string;
    visitors_event_button_text: string;

    visitors_register_title: string;
    visitors_register_subtitle: string;
    visitors_register_description: string;
    visitors_register_link_text: string;
    visitors_register_link: string;
    visitors_register_image: ImageShape;

    visitors_program_title: string;
    visitors_program_description: string;

    visitors_form_title: string;
    visitors_form_description: string;

    visitors_faq_title: string;

    hr_first_screen_title: string;
    hr_first_screen_description: string;

    hr_history_title: string;
    hr_history_description: string;
    hr_history_link_text: string;
    hr_history_link: string;

    hr_people_title: string;

    hr_participate_title: string;
    hr_participate_description: string;
    hr_participate_link_text: string;
    hr_participate_link: string;

    hr_program_title: string;
    hr_program_document: {
        src: string;
        alt: string;
        title: string;
    };

    hr_tariff_title: string;
    hr_tariff_description: string;
    hr_tariff_link_text: string;
    hr_tariff_link: string;
    hr_tariff_discount: string;

    hr_company_title: string;

    hr_about_title: string;
    hr_about_subtitle: string;
    hr_about_description: string;
    hr_about_image: ImageShape;

    hr_nominations_title: string;

    hr_selection_stages_title: string;
    hr_selection_stages_documents: {
        src: string;
        alt: string;
        title: string;
    }[];

    hr_form_title: string;
    hr_form_description: string;

    technological_first_screen_title: string;
    technological_first_screen_description: string;
    technological_first_screen_document: {
        src: string;
        alt: string;
        title: string;
    };

    technological_history_title: string;
    technological_history_description: string;
    technological_history_link_text: string;
    technological_history_link: string;

    technological_participate_title: string;
    technological_participate_description: string;
    technological_participate_link_text: string;
    technological_participate_link: string;

    technological_about_title: string;
    technological_about_subtitle: string;
    technological_about_description: string;
    technological_about_image: ImageShape;
    technological_about_link_text: string;
    technological_about_link: string;

    technological_company_title: string;
    technological_company_description: string;

    technological_directions_title: string;
    technological_directions_document: {
        src: string;
        alt: string;
        title: string;
    };

    technological_selection_stages_title: string;
    technological_selection_stages_documents: {
        src: string;
        alt: string;
        title: string;
    }[];

    technological_reviews_title: string;
    technological_reviews_description: string;

    technological_form_title: string;
    technological_form_description: string;
    technological_form_link_text: string;
    technological_form_link: string;

    expo_first_screen_title: string;
    expo_first_screen_description: string;
    expo_first_screen_video: {
        src: string;
        type: string;
    }[];
    expo_first_screen_images: ImageShape[];
    expo_constructor_title: string;
    expo_constructor_button_text: string;
    expo_constructor_documents: {
        src: string;
        alt: string;
        title: string;
    }[];
    expo_company_title: string;
    expo_history_title: string;
    expo_history_description: string;
    expo_history_link_text: string;
    expo_history_link: string;
    expo_review_title: string;
    expo_review_description: string;
    expo_form_title: string;
    expo_form_description: string;
    expo_faq_title: string;

    program_first_screen_title: string;
    program_first_screen_subtitle: string;

    program_other_event_title: string;
    program_other_event_description: string;
    program_other_event_button_text: string;

    program_faq_title: string;

    program_form_title: string;
    program_form_description: string;

    calendar_first_screen_title: string;

    post_first_screen_title: string;
    post_first_screen_desription: string;
    post_first_screen_button_text: string;

    hotel_first_screen_title: string;
    hotel_first_screen_desription: string;
    hotel_first_screen_link: string;
    hotel_first_screen_link_text: string;

    hotel_hotels_title: string;
    hotel_hotels_desription: string;
    hotel_hotels_link: string;
    hotel_hotels_link_text: string;

    hotel_contact_title: string;
    hotel_contact_desription: string;

    car_first_screen_title: string;
    car_first_screen_desription: string;
    car_first_screen_link: string;
    car_first_screen_link_text: string;

    car_cars_title: string;
    car_cars_desription: string;
    car_cars_button_text: string;

    car_conditions_title: string;
    car_conditions_desription: string;
    car_contact_title: string;
    car_contact_desription: string;

    accreditation_first_screen_title: string;
    accreditation_first_screen_desription: string;
    accreditation_first_screen_link: string;
    accreditation_first_screen_link_text: string;
    accreditation_accreditation_title: string;
    accreditation_accreditation_desription: string;
    accreditation_scheme_title: string;
    accreditation_scheme_document: {
        src: string;
        alt: string;
        title: string;
    };
    accreditation_contact_title: string;
    accreditation_contact_desription: string;

    shuttles_first_screen_title: string;
    shuttles_first_screen_desription: string;
    shuttles_first_screen_link: string;
    shuttles_first_screen_link_text: string;

    shuttles_about_title: string;
    shuttles_about_desription: string;
    shuttles_about_document: {
        src: string;
        alt: string;
        title: string;
    };

    shuttles_contact_title: string;
    shuttles_contact_desription: string;

    zone_first_screen_title: string;
    zone_first_screen_desription: string;
    zone_first_screen_link: string;
    zone_first_screen_link_text: string;

    zone_zones_title: string;

    zone_contact_title: string;
    zone_contact_desription: string;

    exchange_contacts_first_screen_title: string;
    exchange_contacts_first_screen_desription: string;
    exchange_contacts_tariff_title: string;
    exchange_contacts_tariff_desription: string;
    exchange_contacts_tariff_link_text: string;
    exchange_contacts_tariff_link: string;
    exchange_contacts_contact_title: string;
    exchange_contacts_contact_desription: string;

    register_first_screen_title: string;
    register_first_screen_desription: string;

    register_form_title: string;
    register_form_description: string;
    register_form_link_text: string;
    register_form_link: string;

    register_faq_title: string;

    privacy_content_text: string;

    contacts_first_screen_title: string;
    contacts_first_screen_desription: string;
    contacts_first_screen_link: string;
    contacts_first_screen_link_text: string;

    contacts_default_document_oferta: {
        src: string;
        alt: string;
        title: string;
    };
    contacts_default_phone: string;
    contacts_default_email: string;
    contacts_default_support_link: string;
    contacts_default_postal_сode: string;
    contacts_default_city: string;
    contacts_default_street: string;
    contacts_default_location: string;
    contacts_default_name: string;

    contacts_command_title: string;

    footer_default_form_text: string;

    premiya_tec_first_screen_title: string;
    premiya_tec_first_screen_description: string;

    premiya_tec_company_title: string;

    premiya_tec_about_title: string;
    premiya_tec_about_subtitle: string;
    premiya_tec_about_description: string;
    premiya_tec_about_image: ImageShape;

    premiya_tec_participate_title: string;
    premiya_tec_nominations_title: string;

    premiya_tec_selection_stages_title: string;
    premiya_tec_selection_stages_documents: {
        src: string;
        alt: string;
        title: string;
    }[];

    premiya_tec_form_title: string;
    premiya_tec_form_description: string;

    premiya_tec_participate_description: string;
    premiya_tec_participate_link_text: string;
    premiya_tec_participate_link: string;

    premiya_tec_form_link_text: string;
    premiya_tec_form_link: string;

    premiya_tec_about_link_text: string;
    premiya_tec_about_link: string;
}>;

export type ApiSiteSettingsRequest = {
    keys: (keyof SiteSettingsKeys)[];
};

type Params = {
    params: ApiSiteSettingsRequest;
    locale?: AppLocale;
    signal?: AbortSignal;
};

export type ApiSiteSettingsResponse = ApiResponse<SiteSettingsKeys>;

export const getSiteSettings = ({
    params,
    signal,
    locale = DEFAULT_LOCALE,
}: Params): Promise<ApiSiteSettingsResponse> =>
    axiosAPI
        .get<ApiSiteSettingsResponse>('/v1/settings', { params, signal, headers: { 'App-Locale': locale } })
        .then((res) => res.data);
